import { a as n, j as t } from "../../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import "@ionic/react";
import "../../../../../FeatureFlagProvider-Dk-Rz1cD.js";
import "react";
import "../../../../../react-paginate-Lh5zQzpz.js";
import { ButtonEdit as r } from "../ButtonEdit/ButtonEdit.js";
import "../../../LoadingInterstitial/LoadingInterstitial.js";
import "../../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
import '../../../../../css/Section.css';const c = "_section_fjl6j_1", l = {
  section: c
};
function y(e) {
  const {
    children: o,
    title: s,
    onEditClick: i
  } = e;
  return /* @__PURE__ */ n("div", {
    className: l.section,
    children: [/* @__PURE__ */ n("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 24
      },
      children: [/* @__PURE__ */ t("h2", {
        style: {
          margin: 0,
          fontSize: "var(--swing-font-xl) !important"
        },
        children: s
      }), i && // avoid button 100% width default
      /* @__PURE__ */ t("div", {
        children: /* @__PURE__ */ t(r, {
          onClick: () => i()
        })
      })]
    }), o]
  });
}
export {
  y as Section
};
